import {Component, Input} from '@angular/core';
import {Platform, Product} from '@uofu-uss-aux/software-catalog-ng-core';
import {AsyncPipe, NgForOf, NgIf} from '@angular/common';
import {RouterLink} from '@angular/router';
import {SpinnerComponent} from '../../svg/spinner/spinner.component';
import {PlatformComponent} from '../../product/platform/platform.component';
import {CatalogGraphicComponent} from '../../graphic/catalog-graphic/catalog-graphic.component';

/**
 * Presentation component for an entry in the downloads without available
 * purchases index.
 *
 * Should be initialized with all fields at once.
 * Otherwise, this will display a spinner placeholder when product isn't set.
 */
@Component({
  selector: 'app-download-without-purchase-entry',
  templateUrl: './download-without-purchase-entry.component.html',
  styleUrls: ['./download-without-purchase-entry.component.scss'],
  standalone: true,
  imports: [
    NgForOf,
    RouterLink,
    SpinnerComponent,
    NgIf,
    AsyncPipe,
    PlatformComponent,
    CatalogGraphicComponent,
  ]
})
export class DownloadWithoutPurchaseEntryComponent {

  @Input()
  product: Product;

  @Input()
  platforms: readonly Platform[];

  @Input()
  version: string;

}
